var cov_1yj6m1i7zt = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/Quarter.tsx",
      hash = "e6373dd64bc2a73518d714a4002a05fa993b31ba",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/Quarter.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 17
        },
        end: {
          line: 10,
          column: 41
        }
      },
      "1": {
        start: {
          line: 18,
          column: 4
        },
        end: {
          line: 18,
          column: 16
        }
      },
      "2": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 61
        }
      },
      "3": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 62
        }
      },
      "4": {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 64
        }
      },
      "5": {
        start: {
          line: 22,
          column: 4
        },
        end: {
          line: 22,
          column: 56
        }
      },
      "6": {
        start: {
          line: 24,
          column: 4
        },
        end: {
          line: 24,
          column: 71
        }
      },
      "7": {
        start: {
          line: 28,
          column: 25
        },
        end: {
          line: 28,
          column: 35
        }
      },
      "8": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 29,
          column: 63
        }
      },
      "9": {
        start: {
          line: 33,
          column: 34
        },
        end: {
          line: 33,
          column: 44
        }
      },
      "10": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 34,
          column: 100
        }
      },
      "11": {
        start: {
          line: 38,
          column: 4
        },
        end: {
          line: 38,
          column: 35
        }
      },
      "12": {
        start: {
          line: 42,
          column: 25
        },
        end: {
          line: 42,
          column: 35
        }
      },
      "13": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 71
        }
      },
      "14": {
        start: {
          line: 47,
          column: 66
        },
        end: {
          line: 47,
          column: 76
        }
      },
      "15": {
        start: {
          line: 49,
          column: 21
        },
        end: {
          line: 49,
          column: 86
        }
      },
      "16": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 52,
          column: 5
        }
      },
      "17": {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 51,
          column: 84
        }
      },
      "18": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 56,
          column: 5
        }
      },
      "19": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 55,
          column: 33
        }
      },
      "20": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 67,
          column: 5
        }
      },
      "21": {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 66,
          column: 7
        }
      },
      "22": {
        start: {
          line: 65,
          column: 8
        },
        end: {
          line: 65,
          column: 25
        }
      },
      "23": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 68,
          column: 21
        }
      },
      "24": {
        start: {
          line: 72,
          column: 49
        },
        end: {
          line: 72,
          column: 59
        }
      },
      "25": {
        start: {
          line: 73,
          column: 17
        },
        end: {
          line: 73,
          column: 70
        }
      },
      "26": {
        start: {
          line: 74,
          column: 17
        },
        end: {
          line: 74,
          column: 77
        }
      },
      "27": {
        start: {
          line: 75,
          column: 23
        },
        end: {
          line: 75,
          column: 48
        }
      },
      "28": {
        start: {
          line: 77,
          column: 22
        },
        end: {
          line: 77,
          column: 48
        }
      },
      "29": {
        start: {
          line: 78,
          column: 4
        },
        end: {
          line: 95,
          column: 5
        }
      },
      "30": {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 81,
          column: 7
        }
      },
      "31": {
        start: {
          line: 80,
          column: 8
        },
        end: {
          line: 80,
          column: 32
        }
      },
      "32": {
        start: {
          line: 91,
          column: 11
        },
        end: {
          line: 95,
          column: 5
        }
      },
      "33": {
        start: {
          line: 92,
          column: 6
        },
        end: {
          line: 94,
          column: 7
        }
      },
      "34": {
        start: {
          line: 93,
          column: 8
        },
        end: {
          line: 93,
          column: 32
        }
      },
      "35": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 104,
          column: 5
        }
      },
      "36": {
        start: {
          line: 108,
          column: 24
        },
        end: {
          line: 108,
          column: 34
        }
      },
      "37": {
        start: {
          line: 109,
          column: 4
        },
        end: {
          line: 122,
          column: 5
        }
      },
      "38": {
        start: {
          line: 120,
          column: 73
        },
        end: {
          line: 120,
          column: 97
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 17,
            column: 2
          },
          end: {
            line: 17,
            column: 3
          }
        },
        loc: {
          start: {
            line: 17,
            column: 39
          },
          end: {
            line: 25,
            column: 3
          }
        },
        line: 17
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        loc: {
          start: {
            line: 27,
            column: 15
          },
          end: {
            line: 30,
            column: 3
          }
        },
        line: 27
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        },
        loc: {
          start: {
            line: 32,
            column: 33
          },
          end: {
            line: 35,
            column: 3
          }
        },
        line: 32
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 37,
            column: 2
          },
          end: {
            line: 37,
            column: 3
          }
        },
        loc: {
          start: {
            line: 37,
            column: 20
          },
          end: {
            line: 39,
            column: 3
          }
        },
        line: 37
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 41,
            column: 2
          },
          end: {
            line: 41,
            column: 3
          }
        },
        loc: {
          start: {
            line: 41,
            column: 33
          },
          end: {
            line: 44,
            column: 3
          }
        },
        line: 41
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 46,
            column: 3
          }
        },
        loc: {
          start: {
            line: 46,
            column: 29
          },
          end: {
            line: 69,
            column: 3
          }
        },
        line: 46
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 71,
            column: 2
          },
          end: {
            line: 71,
            column: 3
          }
        },
        loc: {
          start: {
            line: 71,
            column: 38
          },
          end: {
            line: 105,
            column: 3
          }
        },
        line: 71
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 107,
            column: 2
          },
          end: {
            line: 107,
            column: 3
          }
        },
        loc: {
          start: {
            line: 107,
            column: 11
          },
          end: {
            line: 123,
            column: 3
          }
        },
        line: 107
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 120,
            column: 63
          },
          end: {
            line: 120,
            column: 64
          }
        },
        loc: {
          start: {
            line: 120,
            column: 73
          },
          end: {
            line: 120,
            column: 97
          }
        },
        line: 120
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 49,
            column: 21
          },
          end: {
            line: 49,
            column: 86
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 49,
            column: 21
          },
          end: {
            line: 49,
            column: 24
          }
        }, {
          start: {
            line: 49,
            column: 28
          },
          end: {
            line: 49,
            column: 86
          }
        }],
        line: 49
      },
      "1": {
        loc: {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }, {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }],
        line: 50
      },
      "2": {
        loc: {
          start: {
            line: 51,
            column: 19
          },
          end: {
            line: 51,
            column: 84
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 51,
            column: 19
          },
          end: {
            line: 51,
            column: 22
          }
        }, {
          start: {
            line: 51,
            column: 26
          },
          end: {
            line: 51,
            column: 84
          }
        }],
        line: 51
      },
      "3": {
        loc: {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 56,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 56,
            column: 5
          }
        }, {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 56,
            column: 5
          }
        }],
        line: 54
      },
      "4": {
        loc: {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 54,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 54,
            column: 19
          }
        }, {
          start: {
            line: 54,
            column: 23
          },
          end: {
            line: 54,
            column: 41
          }
        }, {
          start: {
            line: 54,
            column: 45
          },
          end: {
            line: 54,
            column: 75
          }
        }],
        line: 54
      },
      "5": {
        loc: {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 67,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 67,
            column: 5
          }
        }, {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 67,
            column: 5
          }
        }],
        line: 59
      },
      "6": {
        loc: {
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 59,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 59,
            column: 8
          },
          end: {
            line: 59,
            column: 19
          }
        }, {
          start: {
            line: 59,
            column: 23
          },
          end: {
            line: 59,
            column: 34
          }
        }, {
          start: {
            line: 59,
            column: 38
          },
          end: {
            line: 59,
            column: 56
          }
        }],
        line: 59
      },
      "7": {
        loc: {
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 66,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 66,
            column: 7
          }
        }, {
          start: {
            line: 60,
            column: 6
          },
          end: {
            line: 66,
            column: 7
          }
        }],
        line: 60
      },
      "8": {
        loc: {
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 63,
            column: 92
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 61,
            column: 8
          },
          end: {
            line: 61,
            column: 23
          }
        }, {
          start: {
            line: 62,
            column: 8
          },
          end: {
            line: 62,
            column: 20
          }
        }, {
          start: {
            line: 63,
            column: 8
          },
          end: {
            line: 63,
            column: 92
          }
        }],
        line: 61
      },
      "9": {
        loc: {
          start: {
            line: 77,
            column: 23
          },
          end: {
            line: 77,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 77,
            column: 23
          },
          end: {
            line: 77,
            column: 33
          }
        }, {
          start: {
            line: 77,
            column: 37
          },
          end: {
            line: 77,
            column: 47
          }
        }],
        line: 77
      },
      "10": {
        loc: {
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 95,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 95,
            column: 5
          }
        }, {
          start: {
            line: 78,
            column: 4
          },
          end: {
            line: 95,
            column: 5
          }
        }],
        line: 78
      },
      "11": {
        loc: {
          start: {
            line: 78,
            column: 8
          },
          end: {
            line: 78,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 78,
            column: 8
          },
          end: {
            line: 78,
            column: 17
          }
        }, {
          start: {
            line: 78,
            column: 21
          },
          end: {
            line: 78,
            column: 40
          }
        }],
        line: 78
      },
      "12": {
        loc: {
          start: {
            line: 79,
            column: 6
          },
          end: {
            line: 81,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 79,
            column: 6
          },
          end: {
            line: 81,
            column: 7
          }
        }, {
          start: {
            line: 79,
            column: 6
          },
          end: {
            line: 81,
            column: 7
          }
        }],
        line: 79
      },
      "13": {
        loc: {
          start: {
            line: 91,
            column: 11
          },
          end: {
            line: 95,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 91,
            column: 11
          },
          end: {
            line: 95,
            column: 5
          }
        }, {
          start: {
            line: 91,
            column: 11
          },
          end: {
            line: 95,
            column: 5
          }
        }],
        line: 91
      },
      "14": {
        loc: {
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 94,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 94,
            column: 7
          }
        }, {
          start: {
            line: 92,
            column: 6
          },
          end: {
            line: 94,
            column: 7
          }
        }],
        line: 92
      },
      "15": {
        loc: {
          start: {
            line: 100,
            column: 17
          },
          end: {
            line: 100,
            column: 93
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 100,
            column: 30
          },
          end: {
            line: 100,
            column: 39
          }
        }, {
          start: {
            line: 100,
            column: 42
          },
          end: {
            line: 100,
            column: 93
          }
        }],
        line: 100
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0, 0],
      "5": [0, 0],
      "6": [0, 0, 0],
      "7": [0, 0],
      "8": [0, 0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _toConsumableArray from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/DatePicker/Quarter.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import Icon from './Icon';
import utils from './utils';
import paramUtils from './paramUtils';
import { datepickerClass } from './styles';
import { getLocale } from '../locale';
import { isArray, isNumber } from '../utils/is';
var Quarters = (cov_1yj6m1i7zt.s[0]++, ['Q1', 'Q2', 'Q3', 'Q4']);

var Quarter =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Quarter, _PureComponent);

  var _super = _createSuper2(Quarter);

  function Quarter(props) {
    var _this;

    _classCallCheck(this, Quarter);

    cov_1yj6m1i7zt.f[0]++;
    cov_1yj6m1i7zt.s[1]++;
    _this = _super.call(this, props);
    _this.handleNextYear = void 0;
    _this.handlePrevYear = void 0;
    cov_1yj6m1i7zt.s[2]++;
    _this.handleNextYear = _this.handleYearChange.bind(_assertThisInitialized(_this), 1);
    cov_1yj6m1i7zt.s[3]++;
    _this.handlePrevYear = _this.handleYearChange.bind(_assertThisInitialized(_this), -1);
    cov_1yj6m1i7zt.s[4]++;
    _this.handleQuarterClick = _this.handleQuarterClick.bind(_assertThisInitialized(_this));
    cov_1yj6m1i7zt.s[5]++;
    _this.handleDisabled = _this.handleDisabled.bind(_assertThisInitialized(_this));
    cov_1yj6m1i7zt.s[6]++;
    props.disabledRegister(_this.handleDisabled, 'quarter', props.index);
    return _this;
  }

  _createClass(Quarter, [{
    key: "getOptions",
    value: function getOptions() {
      cov_1yj6m1i7zt.f[1]++;

      var _ref = (cov_1yj6m1i7zt.s[7]++, this.props),
          timeZone = _ref.timeZone;

      cov_1yj6m1i7zt.s[8]++;
      return {
        timeZone: timeZone,
        weekStartsOn: getLocale('startOfWeek')
      };
    }
  }, {
    key: "handleYearChange",
    value: function handleYearChange(year) {
      cov_1yj6m1i7zt.f[2]++;

      var _ref2 = (cov_1yj6m1i7zt.s[9]++, this.props),
          current = _ref2.current,
          onChange = _ref2.onChange;

      cov_1yj6m1i7zt.s[10]++;
      onChange.apply(void 0, _toConsumableArray(paramUtils.yearHandleChangeParams(utils.addYears(current, year, this.getOptions()))));
    }
  }, {
    key: "handleYearClick",
    value: function handleYearClick() {
      cov_1yj6m1i7zt.f[3]++;
      cov_1yj6m1i7zt.s[11]++;
      this.props.onModeChange('year');
    }
  }, {
    key: "handleQuarterClick",
    value: function handleQuarterClick(date) {
      cov_1yj6m1i7zt.f[4]++;

      var _ref3 = (cov_1yj6m1i7zt.s[12]++, this.props),
          onChange = _ref3.onChange;

      cov_1yj6m1i7zt.s[13]++;
      onChange.apply(void 0, _toConsumableArray(paramUtils.quarterHandleChangeParams(date, true, true)));
    }
  }, {
    key: "handleDisabled",
    value: function handleDisabled(date) {
      cov_1yj6m1i7zt.f[5]++;

      var _ref4 = (cov_1yj6m1i7zt.s[14]++, this.props),
          disabled = _ref4.disabled,
          index = _ref4.index,
          min = _ref4.min,
          max = _ref4.max,
          rangeDate = _ref4.rangeDate,
          range = _ref4.range,
          type = _ref4.type;

      var isDisabled = (cov_1yj6m1i7zt.s[15]++, (cov_1yj6m1i7zt.b[0][0]++, min) && (cov_1yj6m1i7zt.b[0][1]++, utils.compareQuarter(min, date, 1, this.getOptions()) >= 0));
      cov_1yj6m1i7zt.s[16]++;

      if (!isDisabled) {
        cov_1yj6m1i7zt.b[1][0]++;
        cov_1yj6m1i7zt.s[17]++;
        isDisabled = (cov_1yj6m1i7zt.b[2][0]++, max) && (cov_1yj6m1i7zt.b[2][1]++, utils.compareQuarter(date, max, 1, this.getOptions()) >= 0);
      } else {
        cov_1yj6m1i7zt.b[1][1]++;
      }

      cov_1yj6m1i7zt.s[18]++;

      if ((cov_1yj6m1i7zt.b[4][0]++, !isDisabled) && (cov_1yj6m1i7zt.b[4][1]++, type === 'quarter') && (cov_1yj6m1i7zt.b[4][2]++, typeof disabled === 'function')) {
        cov_1yj6m1i7zt.b[3][0]++;
        cov_1yj6m1i7zt.s[19]++;
        isDisabled = disabled(date);
      } else {
        cov_1yj6m1i7zt.b[3][1]++;
      }

      cov_1yj6m1i7zt.s[20]++;

      if ((cov_1yj6m1i7zt.b[6][0]++, !isDisabled) && (cov_1yj6m1i7zt.b[6][1]++, index === 1) && (cov_1yj6m1i7zt.b[6][2]++, isArray(rangeDate))) {
        cov_1yj6m1i7zt.b[5][0]++;
        cov_1yj6m1i7zt.s[21]++;

        if ((cov_1yj6m1i7zt.b[8][0]++, isNumber(range)) && (cov_1yj6m1i7zt.b[8][1]++, rangeDate[0]) && (cov_1yj6m1i7zt.b[8][2]++, utils.compareAsc(date, utils.addSeconds(rangeDate[0], range, this.getOptions())) > 0)) {
          cov_1yj6m1i7zt.b[7][0]++;
          cov_1yj6m1i7zt.s[22]++;
          isDisabled = true;
        } else {
          cov_1yj6m1i7zt.b[7][1]++;
        }
      } else {
        cov_1yj6m1i7zt.b[5][1]++;
      }

      cov_1yj6m1i7zt.s[23]++;
      return isDisabled;
    }
  }, {
    key: "renderQuarter",
    value: function renderQuarter(q, i) {
      cov_1yj6m1i7zt.f[6]++;

      var _ref5 = (cov_1yj6m1i7zt.s[24]++, this.props),
          current = _ref5.current,
          index = _ref5.index,
          rangeDate = _ref5.rangeDate,
          value = _ref5.value;

      var year = (cov_1yj6m1i7zt.s[25]++, utils.getDateInfo(current, 'year', this.getOptions()));
      var date = (cov_1yj6m1i7zt.s[26]++, utils.parse("".concat(year, " ").concat(i + 1), 'YYYY Q', this.getOptions()));
      var isDisabled = (cov_1yj6m1i7zt.s[27]++, this.handleDisabled(date)); // let hoverClass

      var classList = (cov_1yj6m1i7zt.s[28]++, [(cov_1yj6m1i7zt.b[9][0]++, isDisabled) && (cov_1yj6m1i7zt.b[9][1]++, 'disabled')]);
      cov_1yj6m1i7zt.s[29]++;

      if ((cov_1yj6m1i7zt.b[11][0]++, rangeDate) && (cov_1yj6m1i7zt.b[11][1]++, index !== undefined)) {
        cov_1yj6m1i7zt.b[10][0]++;
        cov_1yj6m1i7zt.s[30]++;

        if (utils.isSameQuarter(date, rangeDate[index], this.getOptions())) {
          cov_1yj6m1i7zt.b[12][0]++;
          cov_1yj6m1i7zt.s[31]++;
          classList.push('active');
        } else {
          cov_1yj6m1i7zt.b[12][1]++;
        } // hoverClass = datepickerClass(
        //   rangeDate[0] &&
        //     utils.compareQuarter(rangeDate[0], date) <= 0 &&
        //     rangeDate[1] &&
        //     utils.compareQuarter(rangeDate[1], date) >= 0 &&
        //     'hover',
        //   // Datetime Picker range end datetime classname #330
        //   utils.isSameQuarter(rangeDate[index], date) && `hover-${index === 0 ? 'start' : 'end'} active`
        // )

      } else {
        cov_1yj6m1i7zt.b[10][1]++;
        cov_1yj6m1i7zt.s[32]++;

        if (value) {
          cov_1yj6m1i7zt.b[13][0]++;
          cov_1yj6m1i7zt.s[33]++;

          if (utils.isSameQuarter(date, value, this.getOptions())) {
            cov_1yj6m1i7zt.b[14][0]++;
            cov_1yj6m1i7zt.s[34]++;
            classList.push('active');
          } else {
            cov_1yj6m1i7zt.b[14][1]++;
          }
        } else {
          cov_1yj6m1i7zt.b[13][1]++;
        }
      }

      cov_1yj6m1i7zt.s[35]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          key: date.getTime() // className={hoverClass}
          ,
          onClick: isDisabled ? (cov_1yj6m1i7zt.b[15][0]++, undefined) : (cov_1yj6m1i7zt.b[15][1]++, this.handleQuarterClick.bind(this, date, undefined)),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 97,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("span", {
          className: datepickerClass.apply(void 0, classList),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 102,
            columnNumber: 9
          }
        }, q))
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      cov_1yj6m1i7zt.f[7]++;

      var _ref6 = (cov_1yj6m1i7zt.s[36]++, this.props),
          current = _ref6.current;

      cov_1yj6m1i7zt.s[37]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('quarter-picker'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 110,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('header'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 111,
            columnNumber: 9
          }
        },
        /*#__PURE__*/
        React.createElement(Icon, {
          name: "AngleLeft",
          className: "left",
          onClick: this.handlePrevYear,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 112,
            columnNumber: 11
          }
        }),
        /*#__PURE__*/
        React.createElement("span", {
          onClick: this.handleYearClick.bind(this),
          className: datepickerClass('ym'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 114,
            columnNumber: 11
          }
        }, utils.getDateInfo(current, 'year', this.getOptions())),
        /*#__PURE__*/
        React.createElement(Icon, {
          name: "AngleRight",
          className: "right",
          onClick: this.handleNextYear,
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 118,
            columnNumber: 11
          }
        })),
        /*#__PURE__*/
        React.createElement("div", {
          className: datepickerClass('list'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 120,
            columnNumber: 9
          }
        }, Quarters.map(function (q, i) {
          cov_1yj6m1i7zt.f[8]++;
          cov_1yj6m1i7zt.s[38]++;
          return _this2.renderQuarter(q, i);
        })))
      );
    }
  }]);

  return Quarter;
}(PureComponent);

export default Quarter;